import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useBrowserAPI } from "@/hooks/useBrowserAPI";
import { Box } from "@gemini/core";
import { Button } from "@gemini/ui";
import React from "react";
import { navigateTo } from "./utils/utils";
import { useI18n } from "@/shared/hooks";
export const LastSearchButton = ({ lastSearch, shouldDisplayCriteria, criteria, link, redirectToHomePage, }) => {
    const { t } = useI18n();
    const { bWindow } = useBrowserAPI();
    const onPressHandler = () => {
        navigateTo(link, bWindow);
    };
    const relaunchLabel = t("errorpage.restart.search.link");
    const redirectHomeLabel = t("errorpage.redirect.home.link");
    return (_jsxs(_Fragment, { children: [lastSearch && (_jsxs(Box, { display: "flex", flexDirection: "column", children: [shouldDisplayCriteria && (_jsx(Box, { display: "flex", flexWrap: "wrap", typography: "typography.body.16.regular", textAlign: {
                            "breakpoint.base": "center",
                            "breakpoint.lg": "left",
                        }, children: criteria.map((criterion, index) => (_jsxs(React.Fragment, { children: [!!index && (_jsx(Box, { width: "5px", height: "5px", borderRadius: "radius.rounded", marginHorizontal: "spacing.8", backgroundColor: "color.surface.subdued.pressed" })), _jsx(Box, { children: criterion })] }, criterion))) })), !shouldDisplayCriteria && (_jsx(Box, { typography: "typography.body.16.regular", textAlign: {
                            "breakpoint.base": "center",
                            "breakpoint.lg": "left",
                        }, children: lastSearch.title }))] })), _jsxs(Box, { gap: "spacing.16", paddingTop: "spacing.24", display: "flex", flexDirection: {
                    "breakpoint.base": "column",
                    "breakpoint.lg": "unset",
                }, alignItems: {
                    "breakpoint.base": "center",
                    "breakpoint.lg": "unset",
                }, width: "100%", children: [_jsx(Box, { maxWidth: {
                            "breakpoint.base": "100%",
                            "breakpoint.lg": "312px",
                        }, width: "100%", children: _jsx(Button, { href: link, variant: "primary", testId: "relaunch-last-search-button", onPress: onPressHandler, isFullWidth: true, children: relaunchLabel }) }), _jsx(Box, { width: "30px", height: "5px", borderRadius: "radius.rounded", backgroundColor: "color.surface.subdued.hover", display: {
                            "breakpoint.lg": "none",
                        } }), _jsx(Box, { maxWidth: {
                            "breakpoint.base": "unset",
                            "breakpoint.lg": "312px",
                        }, width: "100%", children: _jsx(Button, { variant: "secondary", isFullWidth: true, onPress: redirectToHomePage, children: redirectHomeLabel }) })] })] }));
};
